import { PageName } from '../constants/page-name.constant';

export class ItemsPerPage {
  pageName!: PageName;
  pageSize!: number;
}
